import {
    SET_ORDER,
    SET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS,
    SET_STATE_DROPDOWN,
    SET_VENDORDETAILS_NEXT,
    SET_VENDORDETAILSERROR_COUNT,
    SET_VENDOR_DETAILS,
    SET_IS_SUBMITTED,
    SET_IS_VENDOR_DETAILS
} from './types';

const initialState = {
    orderDetails: {vehicleType: ''},
    nonStandardEquipmentDropDown:{},
    modelDropdown:{},
    yearDropdown:{},
    usedDropdown:{},
    cityDropdown:[],
    stateDropdown:[],
    catalogDetails:[],
    noRecordsMessage: '',
    vendorDetailNext:false,
    vendorerrorCount:'',
    vendorDetails:{},
    isSubmitted:false,
    isVendorDetails:false,
}

const reducer = (state = initialState, action:any) => {
    switch (action.type) {
        case SET_ORDER:
            return {
              ...state,
              orderDetails: action.orderDetails
        }
        case SET_NON_STANDARD_EQUIPMENT_ITEM_DETAILS:
            const catalogDetails = action.catalogDetails;
            const noRecordsMessage=action.noRecordsMessage
            return {
              ...state, 
              catalogDetails: catalogDetails?.length ? [...catalogDetails] : [],
              noRecordsMessage,
            }
        case SET_STATE_DROPDOWN:
            return {
                ...state,
                stateDropdown: action.payload
        }
        case SET_VENDORDETAILS_NEXT:
          return {
            ...state,
            vendorDetailNext: action.vendorDetailNext
          }
          case SET_VENDORDETAILSERROR_COUNT:
            return {
              ...state,
              vendorerrorCount: action.vendorerrorCount
            }
          case SET_VENDOR_DETAILS:
            return {
              ...state,
              vendorDetails: action.addressBookNo
            }
            case SET_IS_VENDOR_DETAILS:
            return {
              ...state,
              isVendorDetails: action.isVendorDetails
            }
            case SET_IS_SUBMITTED:
              return{
                ...state,
                isSubmitted: action.isSubmitted
              }
        default: return state
    }
}

export default reducer